export default "__VITE_ASSET__BLozd27g__"